import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  activityRouter: Array<RouteRecordRaw> = [
    {
        path: '/activity',
        name: '活动管理',
        component: Layout,
        meta: { title: '活动管理', icon: 'icon-pie', alwaysShow: true },
        children: [
            {
                path: 'promotion/list',
                name: '商品促销活动',
                component: () => import('@/views/activity/promotion/List.vue'),
                meta: { title: '商品促销活动', keepAlive: true }
            },
            {
                path: 'promotion/edit',
                name: '商品促销活动编辑',
                component: () => import('@/views/activity/promotion/Edit.vue'),
                meta: { title: '商品促销活动编辑' }
            },
            {
                path: 'final-pay-sale',
                name: '官方实付立减',
                component: () => import('@/views/marketing/FinalPaySale.vue'),
                meta: { title: '官方实付立减' }
            },
            {
                path: 'flash-sale',
                name: '限时抢购列表',
                component: () => import('@/views/activity/flash-sale/List.vue'),
                meta: { title: '限时抢购列表', keepAlive: true }
            },
            {
                path: 'flash-sale-edit',
                name: '限时抢购编辑',
                component: () => import('@/views/activity/flash-sale/Edit.vue'),
                meta: { title: '限时抢购编辑' }
            },
        ]
    }
]

export default activityRouter